import { getBorderWidth, getBorderStyle } from '../../borders/borders.alias';
import { getBorderColor } from '../../colors/colors.alias';
import { VARIANT_DEFAULT, VARIANT_STRONG, ELEMENT_DIVIDER, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Divider',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_STRONG,
    },
    elements: {
        ELEMENT_DIVIDER,
    },
});
export default function getDivider(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_DIVIDER]: {
                styles: {
                    borderColor: borderColor.divider.value,
                    borderStyle: borderStyle.divider.value,
                },
                variants: {
                    [VARIANT_DEFAULT]: {
                        styles: {
                            borderTopWidth: borderWidth.divider.default.value,
                        },
                    },
                    [VARIANT_STRONG]: {
                        styles: {
                            borderTopWidth: borderWidth.divider.strong.value,
                        },
                    },
                },
            },
        },
    });
}
